import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { toIsoFromDateTimeParts } from '@/common/utils/dateUtils';
import { unFormatUnknownUnit } from '@/common/utils/unFormatters';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AuctionEntryProposalValidationSchema } from '../schemas/auctionEntryProposal.schema';

interface UseCreateMaintenanceEstablishmentChoiceAuctionEntryProposalProps {
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    AuctionEntryProposalValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useCreateMaintenanceEstablishmentChoiceAuctionEntryProposal = ({
  options,
}: UseCreateMaintenanceEstablishmentChoiceAuctionEntryProposalProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createMaintenanceEstablishmentChoiceAuctionEntryProposal'],
    mutationFn: (form) => {
      const startAt = toIsoFromDateTimeParts(
        form.directive_proposal_content_attributes.start_at_date,
        form.directive_proposal_content_attributes.start_at_time
      );

      const payload = {
        auction_entry_id: form.auction_entry_id,
        directive_proposal_content_attributes: {
          start_at: startAt,
          deadline_to_complete_in_days: unFormatUnknownUnit(
            form.directive_proposal_content_attributes.deadline_to_complete_in_days
          ),
        }
      };

      return privateAxios.post(`/maintenance/establishment_choice/auction_entry_proposals`, payload);
    },
    ...options
  });
}
